import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import ScriptGeneratorClassifier2Choice from './ScriptGeneratorClassifier2Choice';

const GeneratorClassifier2ChoiceType = ({choices, items, parameters, extraFields}) => (
    <table className="table table-sm">
        <thead>
            <tr>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                {/* <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th> */}
                <th scope="col">Condizione</th>
            </tr>
        </thead>
        <tbody>
            {choices.map((choice) => (
                <tr key={choice.id}>
                    <td className="value-id">{choice.id}</td>
                    <td>{choice.value}</td>
                    <td><ScriptGeneratorClassifier2Choice scripts={choice.choiceScripts} items={items} parameters={parameters} extraFields={extraFields} /></td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default GeneratorClassifier2ChoiceType;
